import { type User } from '@kalos/kalos-rpc';

export const getHasAccessToEmployeeItemOptions = (user: User) => {
  return !!user.permissionGroups.find((group) => group.name === 'Manager');
};
